import { useTranslation } from "react-i18next";
import { CheckCircle2, Clock, ShieldCheck } from "lucide-react";
import { DetailCard } from "./DetailCard";
import { fmtDateTime } from "./detailFmt";

const APPROVED = ["approved", "sent", "partially_received", "received",
                  "accepted", "matched", "posted", "paid", "closed", "billed"];

const StepCard = ({ done, title, subtitle, sub2, tid }) => {
  const Icon = done ? CheckCircle2 : Clock;
  const cls = done ? "bg-emerald-50 border-emerald-200" : "bg-slate-50 border-slate-200";
  const iconCls = done ? "text-emerald-500" : "text-slate-400";
  return (
    <div className={`grid gap-1 rounded-2xl border ${cls} p-4 text-center`} data-testid={tid}>
      <Icon className={`mx-auto h-8 w-8 ${iconCls}`} />
      <p className="text-sm font-bold">{title}</p>
      {subtitle ? <p className="text-[11px] text-muted-foreground">{subtitle}</p> : null}
      {sub2 ? <p className="text-[11px] font-bold text-emerald-700">{sub2}</p> : null}
    </div>
  );
};

const historyOf = (doc, state) =>
  (doc.history || []).find((h) => h.state === state) || null;

export const DetailApproval = ({ doc }) => {
  const { t } = useTranslation();
  const companyDone = APPROVED.includes(doc.state);
  const supplierDone = Boolean(doc.supplier_confirmed);
  const linkSent = Boolean(doc.confirmation_token);
  const approvalEntry = historyOf(doc, "approved") || historyOf(doc, "pending_approval");
  const approverName = doc.approved_by_name || approvalEntry?.by;
  const approvedAt = doc.approved_at || approvalEntry?.at;

  return (
    <DetailCard tid="section-approval" icon={ShieldCheck} tone="emerald"
                title={t("purchases.podetail.approvalStatus")}>
      <div className="mb-3 grid grid-cols-2 gap-3">
        <StepCard done={supplierDone} tid="step-supplier"
                  title={t("purchases.podetail.supplierApproval")}
                  subtitle={supplierDone
                    ? t("purchases.podetail.approved")
                    : linkSent ? t("purchases.podetail.linkSent")
                    : t("purchases.podetail.awaitingSupplierLink")}
                  sub2={supplierDone ? doc.confirmed_by_name : null} />
        <StepCard done={companyDone} tid="step-company"
                  title={t("purchases.podetail.companyApproval")}
                  subtitle={companyDone
                    ? t("purchases.podetail.approved")
                    : t("purchases.podetail.awaitingCompany")}
                  sub2={companyDone ? approverName : null} />
      </div>
      {companyDone && approverName ? (
        <div className="mt-3 grid gap-1 rounded-2xl border border-emerald-200 bg-emerald-50 p-3 text-xs"
             data-testid="approval-meta">
          <p className="font-bold text-emerald-700">{t("purchases.podetail.approvalInfo")}</p>
          <p><span className="text-muted-foreground">{t("purchases.podetail.approvedBy")}:</span>{" "}
             <span className="font-bold">{approverName}</span></p>
          {approvedAt ? (
            <p><span className="text-muted-foreground">{t("purchases.podetail.approvedAt")}:</span>{" "}
               <span className="num font-mono font-bold">{fmtDateTime(approvedAt)}</span></p>
          ) : null}
        </div>
      ) : null}
    </DetailCard>
  );
};
